<template>
  <div>
    <!-- <h3 class="title">{{ msg }}</h3> -->
    <div class="amap-wrapper">
      <div style="position: absolute; top: 20px; left: 50%; transform: translateX(-50%); z-index: 10; width: 300px;background:#fff;">
        <input v-model="searchText" @input="searchAddress" placeholder="请输入互助目标区域" style="width: 100%; padding: 8px; border-radius: 4px; border: 1px solid #ccc; margin-bottom: 4px;" />
        <div style="text-align: left;padding:10px;width:100%;">
          提示：<br />
          <span style="color:red;padding:5px;">
            1.有搜索结果可点击搜索结果获取联系电话即详情<br />
          </span>
          <span style="color:red;padding:5px;">
            2.'无搜索结果'可扩大搜索范围
          </span>
        </div>

        <ul v-if="searchResults.length" style="background: #fff; border: 1px solid #eee; border-radius: 4px; margin: 0; padding: 0; list-style: none; max-height: 200px; overflow-y: auto;">
          <li v-for="item in searchResults" :key="item.id" @click="selectResult(item)" style="padding: 8px; cursor: pointer; border-bottom: 1px solid #f0f0f0;">
            {{ item.name }} <span v-if="item.address">({{ item.address }})</span>
          </li>
        </ul>
      </div>
      <el-amap class="amap-box" :center="center" :zoom="zoom" :vid="'amap-vue'">
        <el-amap-marker v-if="center" :position="center" @click="showInfoWindow"></el-amap-marker>
        <el-amap-marker v-for="marker in fixedMarkers" :key="marker.id"
          :position="marker.position"
          :icon="marker.icon"
          :label="marker.label"
          @click="showFixedInfo(marker)"
        ></el-amap-marker>
        <el-amap-marker :position="[108.93, 34.23]"
          :icon="fixedMarker.icon"
          :label="fixedMarker.label"
          @click="showFixedInfo"
        ></el-amap-marker>
        <el-amap-info-window :position="infoWindowPosition" :visible="infoWindowVisible" :content="infoWindowContent"
          :offset="[0, -30]" />
      </el-amap>
      <van-button icon="map-marked" type="primary" style="position: absolute; bottom:150px; right: 20px;" round @click="getLocation"></van-button>
  <van-button icon="manager-o" type="primary" style="position: absolute; bottom: 80px; right: 20px;" round @click="goPerson"></van-button>
    </div>
  </div>
</template>

<script>
/* 基础地图 */
export default {
  name: 'basicMap',
  data () {
    return {
      fixedMarker: {
        position: [108.93, 34.23],
        icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
        label: {
          content: '自定义点',
          offset: [-20, -30],
          style: {
            color: '#1976d2',
            fontSize: '14px',
            fontWeight: 'bold',
            background: 'rgba(255,255,255,0.8)',
            borderRadius: '4px',
            padding: '2px 6px',
            border: '1px solid #1976d2'
          }
        },
        info: '<div style="color:#1976d2;font-weight:bold;font-size:16px;">自定义点</div><div style="color:#333;">坐标：108.93, 34.23</div><div style="color:#666;font-size:12px;">这是一个自定义样式的标记点</div>'
      },
      msg: '地图',
      center: [116.397428, 39.90923], // 默认北京
      zoom: 12,
      infoWindowVisible: false,
      infoWindowContent: '',
      infoWindowPosition: [116.397428, 39.90923],
      searchText: '',
      searchResults: [],
      fixedMarkers: [
        {
          id: 'marker1',
          position: [108.933819, 34.232934],
          icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
          label: {
            content: '西荷花园',
            offset: [-20, -30],
            style: {
              color: '#1976d2',
              fontSize: '14px',
              fontWeight: 'bold',
              background: 'rgba(255,255,255,0.8)',
              borderRadius: '4px',
              padding: '2px 6px',
              border: '1px solid #1976d2'
            }
          },
          info: '<div style="color:#1976d2;font-weight:bold;font-size:16px;">西安自定义点</div><div style="color:#333;">坐标：108.93, 34.23</div><div style="color:#666;font-size:12px;">这是西安的自定义样式标记点</div>'
        },
        {
          id: 'marker2',
          position: [108.925843, 34.236005],
          icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png',
          label: {
            content: '九锦台',
            offset: [-20, -30],
            style: {
              color: '#d32f2f',
              fontSize: '14px',
              fontWeight: 'bold',
              background: 'rgba(255,255,255,0.8)',
              borderRadius: '4px',
              padding: '2px 6px',
              border: '1px solid #d32f2f'
            }
          },
          info: '<div style="color:#d32f2f;font-weight:bold;font-size:16px;">北京自定义点</div><div style="color:#333;">坐标：116.42, 39.95</div><div style="color:#666;font-size:12px;">这是北京的自定义样式标记点</div>'
        }
      ]
    }
  },
  mounted () {
    this.initAMap()
  },
  methods: {
    goPerson () {
      this.$router.push({ name: 'person' })
    },
    showFixedInfo (marker) {
      this.infoWindowVisible = true
      this.infoWindowPosition = marker.position
      this.infoWindowContent = marker.info
    },
    searchAddress () {
      if (!this.searchText) return
      if (!window.AMap) return
      const placeSearch = new window.AMap.PlaceSearch({ pageSize: 10 })
      placeSearch.search(this.searchText, (status, result) => {
        if (status === 'complete' && result.poiList && result.poiList.pois.length) {
          this.searchResults = result.poiList.pois.map(poi => ({
            id: poi.id,
            name: poi.name,
            address: poi.address,
            location: poi.location
          }))
        } else {
          this.searchResults = []
        }
      })
    },
    selectResult (item) {
      if (item.location) {
        this.center = [item.location.lng, item.location.lat]
        this.zoom = 15
        this.infoWindowPosition = this.center
        this.infoWindowContent = `${item.name}${item.address ? ' - ' + item.address : ''}`
        this.infoWindowVisible = true
        this.searchResults = [] // 选中后清空列表
      }
    },
    initAMap () {
      if (window.AMap && window.AMap.Geolocation) {
        this.getLocation()
      } else {
        // 若AMap未加载，等待其加载后再执行
        window.initAMapCallback = () => {
          this.getLocation()
        }
      }
    },
    getLocation () {
      const geolocation = new window.AMap.Geolocation({
        enableHighAccuracy: true,
        timeout: 10000,
        buttonPosition: 'RB',
        buttonOffset: new window.AMap.Pixel(10, 20),
        zoomToAccuracy: true
      })
      geolocation.getCurrentPosition((status, result) => {
        if (status === 'complete') {
          this.center = [result.position.getLng(), result.position.getLat()]
          this.zoom = 15
          this.infoWindowPosition = this.center
          this.infoWindowVisible = true
          this.infoWindowContent = '我的位置'
          // 让地图视图回到当前位置
          this.$nextTick(() => {
            const amap = this.$el.querySelector('.amap-box')
            if (amap && amap.__vue__) {
              if (amap.__vue__.setCenter) {
                amap.__vue__.setCenter(this.center)
              }
            }
          })
        } else {
          console.error('定位失败', result)
        }
      })
    },
    showInfoWindow () {
      // 点击按钮获取当前位置
      this.infoWindowVisible = true
      this.infoWindowPosition = this.center
      this.infoWindowContent = '我的位置'
    }
  }
}
</script>

<style scoped>
.amap-wrapper {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
}

.amap-box {
  width: 100vw;
  height: 100vh;
}

html,
body {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/basic-map.vue